/**
 * Canonical fuel values (mirrors LISTING_FUEL_TYPE).
 * Defined locally so module init does not depend on circular import timing.
 */
const FUEL = Object.freeze({
  GASOLINE: "gasoline",
  DIESEL: "diesel",
  HYBRID: "hybrid",
  ELECTRIC: "electric",
  GAS: "gas",
});

const GASOLINE_EQUIVALENTS = new Set(["gasoline", "gas", "gasolina"]);

const CANONICAL_FUEL_MATCH_TOKENS = {
  [FUEL.GASOLINE]: ["gasoline", "gas", "gasolina", "corriente", "extra"],
  [FUEL.DIESEL]: ["diesel", "diésel"],
  [FUEL.HYBRID]: [
    "hybrid",
    "hibrido",
    "híbrido",
    "plug in hybrid",
    "plug-in hybrid",
    "phev",
  ],
  [FUEL.ELECTRIC]: ["electric", "electrico", "eléctrico", "ev"],
};

/**
 * Canonical fuel filter value for search UI and URL params.
 */
export function normalizeFuelTypeFilter(value) {
  if (!value || value === "all" || value === "Todos") return null;
  const key = String(value).trim().toLowerCase();
  if (GASOLINE_EQUIVALENTS.has(key) || (key.includes("gasol") && !key.includes("natural"))) {
    return FUEL.GASOLINE;
  }
  if (key.includes("diesel") || key.includes("diésel")) {
    return FUEL.DIESEL;
  }
  if (key.includes("híbr") || key.includes("hybrid") || key.includes("hibrid") || key.includes("phev")) {
    return FUEL.HYBRID;
  }
  if (key.includes("eléct") || key.includes("electric") || key === "ev") {
    return FUEL.ELECTRIC;
  }
  if (key === FUEL.GAS) {
    return FUEL.GASOLINE;
  }
  return key;
}

/** Values that should match when filtering by a canonical fuel type (API + client). */
export function expandFuelTypeFilterMatchTokens(value) {
  const canonical = normalizeFuelTypeFilter(value);
  if (!canonical) return [];
  return CANONICAL_FUEL_MATCH_TOKENS[canonical] || [canonical];
}

export function listingFuelMatchesFuelFilter(listingFuel, filterValues = []) {
  const canonicalFilters = filterValues.map(normalizeFuelTypeFilter).filter(Boolean);
  if (!canonicalFilters.length) return true;

  const listingCanonical = normalizeFuelTypeFilter(listingFuel);
  if (!listingCanonical) return false;
  return canonicalFilters.some((filter) => listingCanonical === filter);
}

export function normalizeFuelTypesFilter(values = []) {
  const canonical = [];
  const seen = new Set();
  values.forEach((value) => {
    const next = normalizeFuelTypeFilter(value);
    if (!next || seen.has(next)) return;
    seen.add(next);
    canonical.push(next);
  });
  return canonical;
}
